import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import WaterAwareness from '../components/WaterAwareness';
import Services from '../components/Services';
import ServiceAreas from '../components/ServiceAreas';
import RentBanner from '../components/RentBanner';
import HowItWorks from '../components/HowItWorks';
import Products from '../components/Products';
import HomeSpares from '../components/HomeSpares';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Home = () => {
  const [cms, setCms] = useState({});

  useEffect(() => {
    // Fetch CMS sections for homepage
    fetch(`${BACKEND_URL}/api/cms/sections/home`)
      .then(r => r.ok ? r.json() : [])
      .then(sections => {
        const map = {};
        sections.forEach(s => {
          if (s.is_visible !== false) {
            map[s.section_type] = s;
          }
        });
        setCms(map);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    const observeAll = () => {
      document.querySelectorAll('.reveal-on-scroll:not(.revealed)').forEach(el => observer.observe(el));
    };

    observeAll();
    const mutationObserver = new MutationObserver(observeAll);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => { observer.disconnect(); mutationObserver.disconnect(); };
  }, []);

  return (
    <div className="min-h-screen" data-testid="home-page">
      <Header />
      <main>
        <Hero cms={cms.hero} />
        <WaterAwareness cms={cms.water_awareness} />
        <Services cms={cms.services} />
        <ServiceAreas variant="home" />
        <RentBanner cms={cms.rent_section} />
        <HowItWorks cms={cms.how_it_works} />
        <Products cms={cms.products} />
        <HomeSpares cms={cms.spare_parts} />
        <WhyChooseUs cms={cms.why_choose_us} />
        <Testimonials cms={cms.testimonials} />
        <ContactForm cms={cms.contact} />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
